/**
 * Google Ads Conversion Tracking
 * 
 * Funkcje do śledzenia konwersji w Google Ads
 * ID konta: AW-17960494434
 * ID konwersji "Wyświetlenie strony": AW-17960494434/zztdCI-WtPobEOLKnfRC
 */

// Sprawdź czy gtag jest dostępny
const isGtagAvailable = () => {
  return typeof window !== 'undefined' && typeof window.gtag === 'function';
};

/**
 * Śledź konwersję rejestracji użytkownika
 */
export const trackRegistration = (userType = 'individual') => {
  if (!isGtagAvailable()) return;
  
  // Główna konwersja Google Ads
  window.gtag('event', 'conversion', {
    'send_to': 'AW-17960494434/zztdCI-WtPobEOLKnfRC'
  });
  
  // Dodatkowy event dla Analytics
  window.gtag('event', 'sign_up', {
    'method': 'email',
    'user_type': userType
  });
  
  console.log('[GA] Registration conversion tracked:', userType);
};

/**
 * Śledź konwersję dodania ogłoszenia
 */
export const trackNewOffer = (category = 'other') => {
  if (!isGtagAvailable()) return;
  
  // Główna konwersja Google Ads
  window.gtag('event', 'conversion', {
    'send_to': 'AW-17960494434/zztdCI-WtPobEOLKnfRC'
  });
  
  // Dodatkowy event
  window.gtag('event', 'generate_lead', {
    'category': category
  });
  
  console.log('[GA] New offer conversion tracked:', category);
};

/**
 * Śledź konwersję kontaktu z firmą (wysłanie wiadomości)
 */
export const trackContactCompany = (companyId) => {
  if (!isGtagAvailable()) return;
  
  window.gtag('event', 'conversion', {
    'send_to': 'AW-17960494434/contact',
    'event_category': 'engagement',
    'event_label': 'company_contact',
    'value': 20,
    'currency': 'PLN'
  });
  
  window.gtag('event', 'contact', {
    'method': 'message',
    'company_id': companyId
  });
  
  console.log('[GA] Company contact tracked:', companyId);
};

/**
 * Śledź konwersję wysłania oferty przez firmę
 */
export const trackOfferResponse = (offerId) => {
  if (!isGtagAvailable()) return;
  
  window.gtag('event', 'conversion', {
    'send_to': 'AW-17960494434/offer_response',
    'event_category': 'engagement',
    'event_label': 'response_sent',
    'value': 25,
    'currency': 'PLN'
  });
  
  console.log('[GA] Offer response tracked:', offerId);
};

/**
 * Śledź wysłanie formularza kontaktowego
 */
export const trackContactForm = () => {
  if (!isGtagAvailable()) return;
  
  window.gtag('event', 'conversion', {
    'send_to': 'AW-17960494434/contact_form',
    'event_category': 'engagement',
    'event_label': 'contact_form',
    'value': 5,
    'currency': 'PLN'
  });
  
  console.log('[GA] Contact form tracked');
};

/**
 * Śledź wyświetlenie strony (pageview)
 */
export const trackPageView = (pagePath, pageTitle) => {
  if (!isGtagAvailable()) return;
  
  window.gtag('event', 'page_view', {
    'page_path': pagePath,
    'page_title': pageTitle
  });
};

/**
 * Śledź kliknięcie w numer telefonu
 */
export const trackPhoneClick = (companyName) => {
  if (!isGtagAvailable()) return;
  
  window.gtag('event', 'conversion', {
    'send_to': 'AW-17960494434/phone_click',
    'event_category': 'engagement',
    'event_label': companyName
  });
  
  console.log('[GA] Phone click tracked:', companyName);
};

export default {
  trackRegistration,
  trackNewOffer,
  trackContactCompany,
  trackOfferResponse,
  trackContactForm,
  trackPageView,
  trackPhoneClick
};
